import React, { useCallback, useState } from 'react';
import { useFeatureToggle } from 'platform/utilities/feature-toggles';
import PasskeyRegistration from './PasskeyRegistration';
import PasskeyManagement from './PasskeyManagement';

export default function PasskeyProfilePage() {
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();
  const identityPasskeyManagementEnabled = useToggleValue(
    TOGGLE_NAMES.identityPasskeyManagementEnabled,
  );
  const [refreshKey, setRefreshKey] = useState(0);
  const handleRegistered = useCallback(() => setRefreshKey(k => k + 1), []);
  // Bumped when a delete flow starts so the registration alert dismisses itself.
  const [dismissSignal, setDismissSignal] = useState(0);
  const handleDeleteFlowStart = useCallback(
    () => setDismissSignal(k => k + 1),
    [],
  );

  return (
    <>
      <PasskeyRegistration
        onRegistered={handleRegistered}
        dismissSignal={dismissSignal}
      />
      {identityPasskeyManagementEnabled && (
        <PasskeyManagement
          refreshKey={refreshKey}
          onDeleteFlowStart={handleDeleteFlowStart}
        />
      )}
      <h2>Learn more about passkeys</h2>
      <p>
        Passkeys are a simple and secure way to sign in. Instead of using a
        password, you’ll confirm it’s you by unlocking your device.
      </p>
      <a href="/resources/create-and-use-passkeys-on-vagov/">
        Learn how to create and use a passkey
      </a>
    </>
  );
}
